import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../lib/queryKeys";
import {
  postMDMDocumentReference,
  postNewConversation,
  postNewMessage,
  updateCDIAlertStatusV2,
  updateConversationStatus,
  updateMessageReadStatus,
  updateVBCAlertStatus,
} from "../../services";

export const useUpdateVBCAlertStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: Record<string, unknown>) =>
      updateVBCAlertStatus(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vbcAlerts"] });
    },
  });
};

export const useUpdateCDIAlertStatusV2 = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: Record<string, unknown>) =>
      updateCDIAlertStatusV2(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cdiAlertsV2"] });
      queryClient.invalidateQueries({ queryKey: ["cdiAlerts"] });
    },
  });
};

export const usePostNewConversation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Record<string, unknown>) => postNewConversation(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conversationList"] });
      queryClient.invalidateQueries({ queryKey: ["unreadConversationCount"] });
    },
  });
};

export const usePostNewMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Record<string, unknown>) => postNewMessage(body),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["conversationMessages"] });
      queryClient.invalidateQueries({ queryKey: ["conversationList"] });
      if (variables?.conversation_id) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.conversationMessages({
            conversation_id: variables.conversation_id,
          }),
        });
      }
    },
  });
};

export const useUpdateMessageReadStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Record<string, unknown>) =>
      updateMessageReadStatus(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conversationMessages"] });
      queryClient.invalidateQueries({ queryKey: ["unreadConversationCount"] });
    },
  });
};

export const useUpdateConversationStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Record<string, unknown>) =>
      updateConversationStatus(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conversationList"] });
    },
  });
};

export const usePostMDMDocumentReference = () =>
  useMutation({
    mutationFn: (body: FormData | Record<string, unknown>) =>
      postMDMDocumentReference(body),
  });
